export class TwoFactorWebAuthnChallengeRequest {
  constructor(public userVerificationToken: string) {}
}
